import type { HTMLAttributes } from 'react'

type RenderHTMLPropTypes = {
  innerHTMLText: string
  className?: string
  onClick?: HTMLAttributes<HTMLDivElement>['onClick']
}

export default function RenderHTML({ innerHTMLText, className, onClick }: RenderHTMLPropTypes) {
  return <div className={className ?? ''} onClick={onClick} dangerouslySetInnerHTML={{ __html: innerHTMLText }} />
}
